export default __webpack_public_path__ + "static/media/sanjulian.830d610c.png";